import $api from "@/frontend/shared/api/axios";

type TExpertCompany = {
  id: number;
  name: string | null;
  description: string | null;
  companyData: {
    id: number;
    name: string;
    description: string | null;
    logoUrl: string | null;
  };
};

export async function getCompaniesForExperts({ id }: { id: number }) {
  const response = await $api.get<{ data: TExpertCompany[] }>(`/organizations/experts/${id}/companies`);
  return response.data.data;
}
